(() => {
  'use strict';

  document.querySelectorAll('[data-aomo-product-details]').forEach((section) => {
    const overview = section.querySelector('[data-aomo-detail-overview]');
    if (!overview) return;

    const firstDivider = overview.querySelector('hr');
    if (firstDivider && firstDivider.parentElement === overview) {
      let node = overview.firstChild;
      while (node && node !== firstDivider) {
        const next = node.nextSibling;
        node.remove();
        node = next;
      }
      firstDivider.remove();
    }

    overview.querySelectorAll('p').forEach((paragraph) => {
      const media = Array.from(paragraph.children).filter((child) => child.matches('img, a:has(img)'));
      if (media.length && !paragraph.textContent.trim()) {
        paragraph.classList.add('aomo-detail-gallery');
        if (media.length === 1) paragraph.classList.add('aomo-detail-gallery--single');
      }
    });

    // Imported product descriptions often contain image tags directly under the
    // rich-text container instead of wrapping them in paragraphs. Group each
    // consecutive run so those images use the same responsive two-column grid.
    let directGallery = null;
    Array.from(overview.childNodes).forEach((node) => {
      const isWhitespace = node.nodeType === Node.TEXT_NODE && !node.textContent.trim();
      const isMedia = node.nodeType === Node.ELEMENT_NODE
        && (node.matches('img') || node.matches('a') && node.querySelector(':scope > img'));

      if (isWhitespace) return;

      if (isMedia) {
        if (!directGallery) {
          directGallery = document.createElement('div');
          directGallery.className = 'aomo-detail-gallery';
          overview.insertBefore(directGallery, node);
        }
        directGallery.appendChild(node);
        return;
      }

      directGallery = null;
    });

    overview.querySelectorAll('.aomo-detail-gallery').forEach((gallery) => {
      gallery.classList.toggle('aomo-detail-gallery--single', gallery.querySelectorAll('img').length === 1);
    });

    overview.querySelectorAll('img').forEach((image) => {
      image.loading = 'lazy';
      image.decoding = 'async';
      image.removeAttribute('width');
      image.removeAttribute('height');
    });

    const panels = Array.from(section.querySelectorAll('[data-aomo-detail-panel]'));
    const tabs = Array.from(section.querySelectorAll('[data-aomo-detail-tab]'));

    const activate = (key, shouldFocus = false) => {
      tabs.forEach((tab) => {
        const selected = tab.dataset.aomoDetailTab === key;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && shouldFocus) tab.focus({ preventScroll: true });
      });

      panels.forEach((panel) => {
        const selected = panel.dataset.aomoDetailPanel === key;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.aomoDetailTab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(index + direction + tabs.length) % tabs.length];
        activate(next.dataset.aomoDetailTab, true);
      });
    });

    section.querySelectorAll('[data-aomo-faq]').forEach((item) => {
      item.querySelector('summary')?.addEventListener('click', () => {
        section.querySelectorAll('[data-aomo-faq][open]').forEach((openItem) => {
          if (openItem !== item) openItem.removeAttribute('open');
        });
      });
    });

    activate('overview');
  });
})();
